import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { settingsApi } from '../api/settings.api';
import type { UpdatePrescriptionSettingsDto } from '../types/settings.types';

export const usePrescriptionSettings = () => {
  return useQuery({
    queryKey: ['prescription-settings'],
    queryFn: () => settingsApi.getPrescriptionSettings(),
  });
};

export const useUpdatePrescriptionSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdatePrescriptionSettingsDto) =>
      settingsApi.updatePrescriptionSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prescription-settings'] });
    },
  });
};

